import * as React from 'react';
import { TerminalCredential } from 'services/clients/credentials';
import { GenericStatus } from './GenericStatus';
import { MissingStatus } from './MissingStatus';

interface Props {
  credential: TerminalCredential;
}

export const StatusColumn: React.FC<Props> = (props) => {
  const { credential } = props;
  const { status } = credential;

  switch (status) {
    case 'missing':
      return <MissingStatus />;
    default:
      return <GenericStatus status={status} />;
  }
};
